// Names of the regions, to display a region saved on a request. Which
// regions are open to company creation comes from the API.
const REGION_NAMES = {
  CM: {
    AD: "Adamaoua",
    CE: "Centre",
    ES: "Est",
    EN: "Extrême-Nord",
    LT: "Littoral",
    NO: "Nord",
    NW: "Nord-Ouest",
    OU: "Ouest",
    SU: "Sud",
    SW: "Sud-Ouest",
  },
};

export const regionName = (country, code) =>
  REGION_NAMES[country]?.[code] || code || "";

// "Bonapriso, Douala (Littoral)"
export const seatAddress = (request) => {
  if (!request?.address) return "";

  const region = regionName(request.country, request.region);

  return region ? `${request.address} (${region})` : request.address;
};
